<template>
  <section class="page-section" v-loading="pageLoading">
    <el-form
      size="small"
      ref="form"
      :model="formData"
      :rules="rules"
      label-width="90px"
      class="content-form pt20"
    >
      <el-form-item label="角色名" prop="name">
        <el-input class="w150" v-model="formData.name"></el-input>
      </el-form-item>
      <el-form-item label="描述" prop="description">
        <el-input class="w300" v-model="formData.description"></el-input>
      </el-form-item>
      <!-- <el-form-item label="编辑权限" prop="description">
                        <el-switch v-model="formData.editFunction" active-color="#13ce66" inactive-color="#999"></el-switch>
                    </el-form-item> -->
      <el-form-item label="权限">
        <el-tree
          :data="treeData"
          show-checkbox
          default-expand-all
          node-key="id"
          :default-checked-keys="treeSelected"
          ref="tree"
          :props="treeProps"
          check-on-click-node
          :expand-on-click-node="false"
        >
        </el-tree>
      </el-form-item>
    </el-form>

    <div class="form-button-wrap">
      <el-button
        type="primary"
        size="small"
        @click="handleSubmit('form')"
        :loading="submitLoading"
        >保存</el-button
      >
      <el-button
        type="default"
        size="small"
        plain
        @click="pageNavigateToPermissionRoleList"
        >取消</el-button
      >
    </div>
  </section>
</template>

<script>
import { permissionRoleDetail, permissionRoleSave } from "@/common/api";

export default {
  data() {
    return {
      id: this.$route.query.id || "",

      pageLoading: false,

      formData: {
        name: "",
        description: "",
        editFunction: true,
      },
      submitLoading: false,

      rules: {
        name: [{ required: true, message: "请输入角色名", trigger: "blur" }],
        description: [
          { required: true, message: "请输入描述", trigger: "blur" },
        ],
      },

      treeData: [
        {
          id: 46,
          label: "看板",
          children: [
            {
              id: 47,
              label: "商品看板",
            },
            {
              id: 48,
              label: "服务看板",
            },
          ],
        },
        {
          id: 4,
          label: "店铺",
          children: [
            {
              id: 5,
              label: "组件管理",
            },
            {
              id: 6,
              label: "广告管理",
            },
            // {
            //     id: 7,
            //     label: '分销商海报'
            // },
            // {
            //     id: 8,
            //     label: '分销商介绍'
            // },
            // {
            //     id: 9,
            //     label: '热门搜索'
            // },
            {
              id: 36,
              label: "店铺设置",
            },
          ],
        },
        {
          id: 50,
          label: "服务",
          children: [
            {
              id: 51,
              label: "服务预约",
            },
            {
              id: 52,
              label: "服务设置",
            },
            {
              id: 53,
              label: "门店信息",
            },
          ],
        },
        {
          id: 10,
          label: "订单",
          children: [
            {
              id: 54,
              label: "服务订单",
            },
            {
              id: 55,
              label: "服务评价",
            },
            {
              label: "商品",
              children: [
                {
                  id: 11,
                  label: "商品订单页面",
                },
                {
                  id: 1001,
                  label: "商品订单导出按钮",
                },
              ],
            },
            {
              id: 12,
              label: "商品评价",
            },
            // {
            //     id: 13,
            //     label: '物流管理'
            // }
          ],
        },
        {
          id: 2,
          label: "商品",
          children: [
            {
              id: 3,
              label: "商品管理",
            },
            {
              id: 49,
              label: "商品专链",
            },
            {
              id: 50,
              label: "商品分组",
            },
          ],
        },
        {
          id: 60,
          label: "会员中心",
          children: [
            {
              id: 60,
              label: "会员",
            },
          ],
        },
        {
          id: 57,
          label: "分销",
          children: [
            {
              id: 58,
              label: "公司代理",
            },
            {
              id: 59,
              label: "个人代理",
            },

            {
              id: 65,
              label: "分销收益",
            },
            {
              id: 66,
              label: "员工排行",
            },
            {
              id: 61,
              label: "员工管理",
            },
            {
              id: 67,
              label: "子代理排行",
            },
            {
              id: 68,
              label: "子代理管理",
            },
            {
              id: 69,
              label: "提现记录",
            },
          ],
        },
        {
          id: 25,
          label: "财务",
          children: [
            {
              id: 70,
              label: "销售数据",
            },
            {
              id: 27,
              label: "退款审核",
            },
            {
              id: 71,
              label: "提现明细",
            },
            {
              id: 63,
              label: "兑换券核销",
            },
          ],
        },
        {
          id: 31,
          label: "权限",
          children: [
            {
              id: 32,
              label: "员工管理",
            },
            {
              id: 33,
              label: "角色管理",
            },
            {
              id: 34,
              label: "操作日志",
            },
            {
              id: 35,
              label: "个人中心",
            },
          ],
        },
        {
          id: 37,
          label: "营销",
          children: [
            {
              id: 38,
              label: "优惠券",
            },
            {
              id: 62,
              label: "兑换券",
            },
            {
              id: 64,
              label: "积分中心",
            },
          ],
        },
        {
          id: 100,
          label: "目标",
          children: [
            {
              id: 100,
              label: "业绩目标",
            },
          ],
        },
      ],
      treeProps: {
        label: "label",
        children: "children",
      },
      treeSelected: [1],
      // treeSelected: []
    };
  },
  methods: {
    // 递归获取所有叶子节点的 ID
    getLeafIds(nodes, leafIds = []) {
      nodes.forEach(node => {
        if (!node.children || node.children.length === 0) {
          if (node.id !== undefined && node.id !== null) {
            leafIds.push(node.id);
          }
        } else {
          this.getLeafIds(node.children, leafIds);
        }
      });
      return leafIds;
    },
    getDetail: function () {
      if (!this.id) {
        this.pageLoading = false;
        return false;
      }

      this.pageLoading = true;

      let params = {
        id: this.id,
      };
      this.treeSelected = [];
      permissionRoleDetail(params)
        .then((res) => {
          let { code, data, msg } = res;

          if (code == 0) {
            this.pageLoading = false;

            this.formData.name = data.name;
            this.formData.description = data.description;
            data.editFunction == 1
              ? (this.formData.editFunction = true)
              : (this.formData.editFunction = false);

            let lists = data.rolePrivileges,
              newList = [];
            if (lists.length > 0) {
              for (let i = 0; i < lists.length; i++) {
                newList.push(lists[i].crmPrivilegesId);
              }
            }

            // 获取本地树结构所有的最底层叶子节点 ID
            const leafIds = this.getLeafIds(this.treeData);
            // 过滤回显：只把是叶子节点的 ID 放入 treeSelected，由 Element 自行联动父节点的勾选状态
            this.treeSelected = newList.filter(id => leafIds.includes(id));
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.$message.error("服务器异常");
        });
    },
    /**
     * [pageNavigateToPermissionRoleList description] 跳转到角色权限列表页
     * @return {[type]} [description]
     */
    pageNavigateToPermissionRoleList: function () {
      this.$router.push({ path: "/permission/role/list" });
    },
    // 保存
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let selectedKeys = this.$refs.tree
            .getCheckedKeys()
            .filter((val) => val !== undefined);
          let params = {
            id: this.id,
            name: this.formData.name,
            description: this.formData.description,
            editFunction: this.formData.editFunction == true ? 1 : 0,
            list: selectedKeys.join(","),
          };
          this.submitLoading = true;
          permissionRoleSave(params)
            .then((res) => {
              this.submitLoading = false;

              let { code, data, msg } = res;

              if (code == 0) {
                this.$message({ message: "保存角色成功", type: "success" });

                // this.$router.push({ path: "/permission/role/list" });
              } else {
                this.$message.error(msg);
              }
            })
            .catch((error) => {
              this.submitLoading = false;
              this.$message.error("服务器异常");
            });
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
    this.getDetail();
  },
};
</script>

<style lang="scss" scoped></style>
